import { PolarisFacilityInfo } from './polarisFacilityList';

/* eslint-disable no-unused-vars */
export enum BusinessType {
    SoleProprietor = 'SoleProprietor',
    Corporation = 'Corporation',
    LimitedLiabilityCompany = 'LimitedLiabilityCompany',
    Partnership = 'Partnership',
    NonProfitOrganization = 'NonProfitOrganization',
    GovernmentOrganization = 'GovernmentOrganization',
}

export enum MerchantStatus {
    NotReady = 'NotReady',
    Ready = 'Ready',
    Boarded = 'Boarded',
    Manual = 'Manual',
    Denied = 'Denied',
    Incomplete = 'Incomplete',
    Pending = 'Pending',
}

export enum AccountStatus {
    NotReady = 'NotReady',
    Ready = 'Ready',
    Challenged = 'Challenged',
    Manual = 'Manual',
    Verified = 'Verified',
}

export enum AccountType {
    Checking = 'Checking',
    Savings = 'Savings',
    CorpChecking = 'CorpChecking',
    CorpSavings = 'CorpSavings',
}

export enum Processor {
    STRIPE = 'Stripe',
    PAYRIX = 'Payrix',
}

export enum TransactionType {
    CreditCardPayment = 'CreditCardPayment',
    ECheckPayment = 'ECheckPayment',
    CreditCardRefund = 'CreditCardRefund',
    ECheckRefund = 'ECheckRefund',
    CreditCardVoid = 'CreditCardVoid',
    CreditCardPreAuth = 'CreditCardPreAuth',
    CreditCardFinalize = 'CreditCardFinalize',
    BacsDebitPayment = 'BacsDebitPayment',
    BecsDebitPayment = 'BecsDebitPayment',
    BacsRefund = 'BacsRefund',
    BecsRefund = 'BecsRefund',
}

export enum TransactionStatus {
    Approved = 'Approved',
    Pending = 'Pending',
    Failed = 'Failed',
    Captured = 'Captured',
    Settled = 'Settled',
    Returned = 'Returned',
    Cancelled = 'Cancelled',
    VerificationPending = 'Verification Pending',
}

export enum ChargebackTabStatus {
    Open = 'Open',
    Closed = 'Closed',
}

export enum type {
    ACHFee = 'AchFee',
    BaseRateFee = 'BaseRateFee',
}

export enum OnboardingStatus {
    NotStorablePayments = 'NotStorablePayments',
    ReadyToOnboard = 'ReadyToOnboard',
    OnboardingSubmitted = 'OnboardingSubmitted',
    Activated = 'Activated',
}

export enum FacilityStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export enum EmployerIdNumberStatus {
    Pending = 'Pending',
    Valid = 'Valid',
    Invalid = 'Invalid',
    NotRequired = 'NotRequired',
}

export enum EmployerIdNumberType {
    SocialSecurityNumber = 'SocialSecurityNumber',
    EmployerIdNumber = 'EmployerIdNumber',
    Other = 'Other',
}

export enum PaymentProcessor {
    Payrix = 'Payrix',
    Stripe = 'Stripe',
}

export enum CardPaymentInterface {
    None = 'None',
    PCCharge = 'PCCharge',
    AuthorizeNet = 'AuthorizeNet',
    PPIPayMover = 'PPIPayMover',
    Advam = 'Advam',
    SmartPayments = 'SmartPayments',
    ChasePaymentTech = 'ChasePaymentTech',
    Netcash = 'Netcash',
    TransFirst = 'TransFirst',
    NABTtransact = 'NABTtransact',
    SiteLinkMerchantServicesUS = 'SiteLinkMerchantServicesUS',
    SiteLinkMerchantServicesCAN = 'SiteLinkMerchantServicesCAN',
    eWay = 'eWay',
    CyberSource = 'CyberSource',
    OpenEdgeEMV = 'OpenEdgeEMV',
    SiteLinkMerchantServicesINT = 'SiteLinkMerchantServicesINT',
    bPointAUS = 'bPointAUS',
    Stripe = 'Stripe',
    StorablePayments = 'StorablePayments',
}

export enum FeeType {
    Discount = 'Discount',
    FlatRate = 'FlatRate',
    Monthly = 'Monthly',
    Annual = 'Annual',
    AnnualPCI = 'AnnualPCI',
    Auth = 'Auth',
}

export enum FeeStatus {
    Paid = 'Paid',
    Unpaid = 'Unpaid',
    Failed = 'Failed',
    Pending = 'Pending',
    Processing = 'Processing',
}
export enum DepositStatus {
    Processed = 'Processed',
    Requested = 'Requested',
    Processing = 'Processing',
    Failed = 'Failed',
    Denied = 'Denied',
    Returned = 'Returned',
}

export enum States {
    AL = 'AL',
    AK = 'AK',
    AZ = 'AZ',
    AR = 'AR',
    CA = 'CA',
    CO = 'CO',
    CT = 'CT',
    DC = 'DC',
    DE = 'DE',
    FL = 'FL',
    GA = 'GA',
    HI = 'HI',
    ID = 'ID',
    IL = 'IL',
    IN = 'IN',
    IA = 'IA',
    KS = 'KS',
    KY = 'KY',
    LA = 'LA',
    ME = 'ME',
    MD = 'MD',
    MA = 'MA',
    MI = 'MI',
    MN = 'MN',
    MS = 'MS',
    MO = 'MO',
    MT = 'MT',
    NE = 'NE',
    NV = 'NV',
    NH = 'NH',
    NJ = 'NJ',
    NM = 'NM',
    NY = 'NY',
    NC = 'NC',
    ND = 'ND',
    OH = 'OH',
    OK = 'OK',
    OR = 'OR',
    PA = 'PA',
    RI = 'RI',
    SC = 'SC',
    SD = 'SD',
    TN = 'TN',
    TX = 'TX',
    UT = 'UT',
    VT = 'VT',
    VA = 'VA',
    VI = 'VI',
    WA = 'WA',
    WV = 'WV',
    WI = 'WI',
    WY = 'WY',
}

export enum MerchantCategory {
    SelfStorage = '4225',
    RealEstateRentals = '6513',
    TrailerParkAndCampgrounds = '7033',
    ParkingLotsAndGarages = '7523',
    Moving = '4214',
}

export enum TransactionTypeFilter {
    All = 'All',
    CreditCard = 'CreditCard',
    ACH = 'ACH',
    BACS = 'BACS',
    BECS = 'BECS',
}

export enum CorpRightOperationType {
    CorporateAdministrator = 'CorporateAdministrator',
    CallCenter = 'CallCenter',
    EditProfile = 'EditProfile',
    WebTemplate = 'WebTemplate',
    SiteManagement = 'SiteManagement',
    RevenueManagement = 'RevenueManagement',
    UsersAndRights = 'UsersAndRights',
    AccountingExport = 'AccountingExport',
    Dashboard = 'Dashboard',
    SiteLinkSearch = 'SiteLinkSearch',
    Promotions = 'Promotions',
    TenantManagement = 'TenantManagement',
    BulletinBoard = 'BulletinBoard',
    BadDebtWriteOff = 'BadDebtWriteOff',
    RefundManagement = 'RefundManagement',
}

export enum TimeZone {
    Est = 'Est',
    Cst = 'Cst',
    Pst = 'Pst',
    Mst = 'Mst',
    Akst = 'Akst',
    Hst = 'Hst',
}

export enum MerchantOnboardStatus {
    'Active' = 'Active',
    'Pending' = 'Pending',
    'Activate' = 'Activate',
    'Failed' = 'Failed',
}

export enum AlertType {
    Success = 'success',
    Danger = 'danger',
    Warning = 'warning',
    Info = 'info',
}

export enum ChargebackStatus {
    Open = 'Open',
    Closed = 'Closed',
    Lost = 'Lost',
    Won = 'Won',
    Pending = 'Pending',
    status = 'Status',
}

export enum ChargebackCycle {
    First = 'First',
    Retrieval = 'Retrieval',
    Representment = 'Representment',
    PreArbitration = 'Pre-Arbitration',
    Arbitration = 'Arbitration',
}
export type StatusKey = 'open' | 'closed' | 'pending' | 'won' | 'lost';

export enum FMS {
    StorEdge = 'storEDGE',
    SiteLink = 'SiteLink',
    EasyStorage = 'EasyStorage',
    NewBook = 'NewBook',
}

export enum StripeAccountOnboardingStatus {
    Failed = 'Failed',
    Verification = 'Verification',
    Completed = 'Completed',
    New = 'New',
    InProgress = 'InProgress',
}

export enum Country {
    USA = 'USA',
    ABW = 'ABW',
    AFG = 'AFG',
    AGO = 'AGO',
    AIA = 'AIA',
    ALA = 'ALA',
    ALB = 'ALB',
    AND = 'AND',
    ARE = 'ARE',
    ARG = 'ARG',
    ARM = 'ARM',
    ASM = 'ASM',
    ATA = 'ATA',
    ATF = 'ATF',
    ATG = 'ATG',
    AUS = 'AUS',
    AUT = 'AUT',
    AZE = 'AZE',
    BDI = 'BDI',
    BEL = 'BEL',
    BEN = 'BEN',
    BES = 'BES',
    BFA = 'BFA',
    BGD = 'BGD',
    BGR = 'BGR',
    BHR = 'BHR',
    BHS = 'BHS',
    BIH = 'BIH',
    BLM = 'BLM',
    BLR = 'BLR',
    BLZ = 'BLZ',
    BMU = 'BMU',
    BOL = 'BOL',
    BRA = 'BRA',
    BRB = 'BRB',
    BRN = 'BRN',
    BTN = 'BTN',
    BVT = 'BVT',
    BWA = 'BWA',
    CAF = 'CAF',
    CAN = 'CAN',
    CCK = 'CCK',
    CHE = 'CHE',
    CHL = 'CHL',
    CHN = 'CHN',
    CIV = 'CIV',
    CMR = 'CMR',
    COD = 'COD',
    COG = 'COG',
    COK = 'COK',
    COL = 'COL',
    COM = 'COM',
    CPV = 'CPV',
    CRI = 'CRI',
    CUB = 'CUB',
    CUW = 'CUW',
    CXR = 'CXR',
    CYM = 'CYM',
    CYP = 'CYP',
    CZE = 'CZE',
    DEU = 'DEU',
    DJI = 'DJI',
    DMA = 'DMA',
    DNK = 'DNK',
    DOM = 'DOM',
    DZA = 'DZA',
    ECU = 'ECU',
    EGY = 'EGY',
    ERI = 'ERI',
    ESH = 'ESH',
    ESP = 'ESP',
    EST = 'EST',
    ETH = 'ETH',
    FIN = 'FIN',
    FJI = 'FJI',
    FLK = 'FLK',
    FRA = 'FRA',
    FRO = 'FRO',
    FSM = 'FSM',
    GAB = 'GAB',
    GBR = 'GBR',
    GEO = 'GEO',
    GGY = 'GGY',
    GHA = 'GHA',
    GIB = 'GIB',
    GIN = 'GIN',
    GLP = 'GLP',
    GMB = 'GMB',
    GNB = 'GNB',
    GNQ = 'GNQ',
    GRC = 'GRC',
    GRD = 'GRD',
    GRL = 'GRL',
    GTM = 'GTM',
    GUF = 'GUF',
    GUM = 'GUM',
    GUY = 'GUY',
    HKG = 'HKG',
    HMD = 'HMD',
    HND = 'HND',
    HRV = 'HRV',
    HTI = 'HTI',
    HUN = 'HUN',
    IDN = 'IDN',
    IMN = 'IMN',
    IND = 'IND',
    IOT = 'IOT',
    IRL = 'IRL',
    IRN = 'IRN',
    IRQ = 'IRQ',
    ISL = 'ISL',
    ISR = 'ISR',
    ITA = 'ITA',
    JAM = 'JAM',
    JEY = 'JEY',
    JOR = 'JOR',
    JPN = 'JPN',
    KAZ = 'KAZ',
    KEN = 'KEN',
    KGZ = 'KGZ',
    KHM = 'KHM',
    KIR = 'KIR',
    KNA = 'KNA',
    KOR = 'KOR',
    KWT = 'KWT',
    LAO = 'LAO',
    LBN = 'LBN',
    LBR = 'LBR',
    LBY = 'LBY',
    LCA = 'LCA',
    LIE = 'LIE',
    LKA = 'LKA',
    LSO = 'LSO',
    LTU = 'LTU',
    LUX = 'LUX',
    LVA = 'LVA',
    MAC = 'MAC',
    MAF = 'MAF',
    MAR = 'MAR',
    MCO = 'MCO',
    MDA = 'MDA',
    MDG = 'MDG',
    MDV = 'MDV',
    MEX = 'MEX',
    MHL = 'MHL',
    MKD = 'MKD',
    MLI = 'MLI',
    MLT = 'MLT',
    MMR = 'MMR',
    MNE = 'MNE',
    MNG = 'MNG',
    MNP = 'MNP',
    MOZ = 'MOZ',
    MRT = 'MRT',
    MSR = 'MSR',
    MTQ = 'MTQ',
    MUS = 'MUS',
    MWI = 'MWI',
    MYS = 'MYS',
    MYT = 'MYT',
    NAM = 'NAM',
    NCL = 'NCL',
    NER = 'NER',
    NFK = 'NFK',
    NGA = 'NGA',
    NIC = 'NIC',
    NIU = 'NIU',
    NLD = 'NLD',
    NOR = 'NOR',
    NPL = 'NPL',
    NRU = 'NRU',
    NZL = 'NZL',
    OMN = 'OMN',
    PAK = 'PAK',
    PAN = 'PAN',
    PCN = 'PCN',
    PER = 'PER',
    PHL = 'PHL',
    PLW = 'PLW',
    PNG = 'PNG',
    POL = 'POL',
    PRI = 'PRI',
    PRK = 'PRK',
    PRT = 'PRT',
    PRY = 'PRY',
    PSE = 'PSE',
    PYF = 'PYF',
    QAT = 'QAT',
    REU = 'REU',
    ROU = 'ROU',
    RUS = 'RUS',
    RWA = 'RWA',
    SAU = 'SAU',
    SDN = 'SDN',
    SEN = 'SEN',
    SGP = 'SGP',
    SGS = 'SGS',
    SHN = 'SHN',
    SJM = 'SJM',
    SLB = 'SLB',
    SLE = 'SLE',
    SLV = 'SLV',
    SMR = 'SMR',
    SOM = 'SOM',
    SPM = 'SPM',
    SRB = 'SRB',
    SSD = 'SSD',
    STP = 'STP',
    SUR = 'SUR',
    SVK = 'SVK',
    SVN = 'SVN',
    SWE = 'SWE',
    SWZ = 'SWZ',
    SXM = 'SXM',
    SYC = 'SYC',
    SYR = 'SYR',
    TCA = 'TCA',
    TCD = 'TCD',
    TGO = 'TGO',
    THA = 'THA',
    TJK = 'TJK',
    TKL = 'TKL',
    TKM = 'TKM',
    TLS = 'TLS',
    TON = 'TON',
    TTO = 'TTO',
    TUN = 'TUN',
    TUR = 'TUR',
    TUV = 'TUV',
    TWN = 'TWN',
    TZA = 'TZA',
    UGA = 'UGA',
    UKR = 'UKR',
    UMI = 'UMI',
    URY = 'URY',
    UZB = 'UZB',
    VAT = 'VAT',
    VCT = 'VCT',
    VEN = 'VEN',
    VGB = 'VGB',
    VIR = 'VIR',
    VNM = 'VNM',
    VUT = 'VUT',
    WLF = 'WLF',
    WSM = 'WSM',
    YEM = 'YEM',
    ZAF = 'ZAF',
    ZMB = 'ZMB',
    ZWE = 'ZWE',
}

export type CountryForFilters = {
    code: string;
    name: string;
    facilities: PolarisFacilityInfo[];
};

export enum FilterStoreType {
    TransactionFilter = 'transaction-filter',
    DepositFilter = 'deposit-filter',
    ChargeBackFilter = 'chargeback-filter',
    StatementFilter = 'statement-filter',
}
export enum PaymentMethodType {
    google_pay = 'GPay',
    apple_pay = 'ApplePay',
}

export enum ConfigurationMode {
    Default = 'default',
    Save = 'save',
    DigitalWallet = 'digitalWallet',
}

export enum CountryName {
    USA = 'USA',
    UK = 'GBR',
    AUS = 'AUS',
    CAN = 'CAN',
}

export enum BankTransferSystem {
    ACH = 'ACH',
    BACS = 'BACS',
    BECS = 'BECS',
}

export interface BankTransferSystemInfo {
    name: BankTransferSystem;
    code: string;
    transactionTypes: string[];
}

export type ProcessorId = '1' | '2';

export const PROCESSOR_ID_MAP: Record<Processor, ProcessorId> = {
    Payrix: '1',
    Stripe: '2',
};
